function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { VectorStyle, createDefaultStyle, DEFAULT_STYLE_NAME } from './VectorStyle';
var AbstractLayer = Oskari.clazz.get('Oskari.mapframework.domain.AbstractLayer');
export var AbstractVectorLayer = /*#__PURE__*/function (_AbstractLayer) {
  function AbstractVectorLayer() {
    var _this;
    _classCallCheck(this, AbstractVectorLayer);
    _this = _callSuper(this, AbstractVectorLayer, arguments);
    _this._hoverOptions = null;
    _this._storedStyleName = null;
    _this._controlData = {};
    return _this;
  }

  /* override */
  _inherits(AbstractVectorLayer, _AbstractLayer);
  return _createClass(AbstractVectorLayer, [{
    key: "selectStyle",
    value: function selectStyle(name) {
      // style is seleced on createMapLayer and styles are loaded async for VectorLayer
      // store selected style name to try selecting it when styles are available
      this._storedStyleName = name;
      // don't create empty style on startup, create it on getCurrentStyle when needed
      if (this.getStyles().length === 0) {
        return;
      }
      // select style (defaults to first)
      _superPropGet(AbstractVectorLayer, "selectStyle", this, 3)([name]);
    }

    /* override */
  }, {
    key: "addStyle",
    value: function addStyle(style) {
      var styles = this.getStyles();
      var index = styles.findIndex(function (s) {
        return s.getName() === style.getName();
      });
      if (index !== -1) {
        styles[index] = style;
      } else {
        styles.push(style);
      }
    }

    /* override */
  }, {
    key: "getCurrentStyle",
    value: function getCurrentStyle() {
      if (!this._currentStyle) {
        if (this.getStyles().length > 0) {
          _superPropGet(AbstractVectorLayer, "selectStyle", this, 3)([this._storedStyleName]);
        } else {
          this._currentStyle = createDefaultStyle(this._storedStyleName);
        }
      }
      return this._currentStyle;
    }

    /* override */
  }, {
    key: "getGeometryType",
    value: function getGeometryType() {
      return this._controlData.simpleGeometryType;
    }

    /* override */
  }, {
    key: "getLegendImage",
    value: function getLegendImage() {
      return null;
    }
  }, {
    key: "setHoverOptions",
    value: function setHoverOptions(options) {
      this._hoverOptions = options;
    }
  }, {
    key: "getHoverOptions",
    value: function getHoverOptions() {
      return this._hoverOptions;
    }
  }, {
    key: "handleDescribeLayer",
    value: function handleDescribeLayer(info) {
      var _info$styles = info.styles,
        styles = _info$styles === void 0 ? [] : _info$styles,
        _info$controlData = info.controlData,
        controlData = _info$controlData === void 0 ? {} : _info$controlData,
        hover = info.hover;
      var vs = styles.map(function (s) {
        return new VectorStyle(s);
      });
      if (vs.length) {
        // override all styles as create map layer if there were any
        this.setStyles(vs);
        // update current style (defaults to first)
        _superPropGet(AbstractVectorLayer, "selectStyle", this, 3)([this._storedStyleName]);
        // request notifies change
        Oskari.getSandbox().postRequestByName('ChangeMapLayerStyleRequest', [this.getId(), this._storedStyleName]);
      }
      this._controlData = controlData;
      this._hoverOptions = hover;
    }
  }, {
    key: "removeStyle",
    value: function removeStyle(name) {
      var styles = this.getStyles();
      var index = styles.findIndex(function (s) {
        return s.getName() === name;
      });
      if (index !== -1) {
        styles.splice(index, 1);
      }
      // Remove style from layer if active.
      var current = this.getCurrentStyle().getName();
      var sb = Oskari.getSandbox();
      if (current === name) {
        sb.postRequestByName('ChangeMapLayerStyleRequest', [this.getId(), DEFAULT_STYLE_NAME]);
      } else {
        // Only notify to update list of styles in selected layers.
        var event = Oskari.eventBuilder('MapLayerEvent')(this.getId(), 'update');
        sb.notifyAll(event);
      }
    }

    /**
     * To get distance between features when clustering kicks in.
     *  @method getClusteringDistance
     *  @return {Number} Distance between features in pixels
     */
  }, {
    key: "getClusteringDistance",
    value: function getClusteringDistance() {
      return this._controlData.clusteringDistance;
    }

    /**
     * To setup clustering. Sets the minimum distance between features before clustering kicks in.
     *  @method setClusteringDistance
     *  @return {Number} Distance between features in pixels
     */
  }, {
    key: "setClusteringDistance",
    value: function setClusteringDistance(distance) {
      this._controlData.clusteringDistance = distance;
    }
  }]);
}(AbstractLayer);
Oskari.clazz.defineES('Oskari.mapframework.domain.AbstractVectorLayer', AbstractVectorLayer);